import script from "./performance-review.vue?vue&type=script&setup=true&lang=js"
export * from "./performance-review.vue?vue&type=script&setup=true&lang=js"

import "./performance-review.vue?vue&type=style&index=0&id=240b0d64&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-240b0d64"]])

export default __exports__